import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';

export const SLIDE_LAYOUT_OPTIONS = [
    { value: "auto", label: "Auto-Generate" },
    { value: "bullets", label: "Bullet Points" },
    { value: "table", label: "Table" },
    { value: "timeline", label: "Timeline" },
    { value: "chevron", label: "Chevron" },
    { value: "labeled_funnel", label: "Labeled-Funnel" },
    { value: "journey", label: "Journey" },
    { value: "detailed_journey", label: "Detailed Journey" },
    { value: "funnel", label: "Funnel" },
    { value: "cycle", label: "Cycle" },
    { value: "matrix", label: "Matrix" },
    { value: "detailed_matrix", label: "Detailed Matrix" },
    { value: "radial_hub", label: "Radial Hub" },
    { value: "venn", label: "Venn" },
    { value: "pyramid", label: "Pyramid" },
    { value: "big_number", label: "Big Number" },
    { value: "chart_sidebar", label: "Chart With Sidebar" },
    { value: "spotlight", label: "Spotlight" },
    { value: "before_after", label: "Before & After" },
    { value: "case_study", label: "Case Study" },
    { value: "qa", label: "Q&A" }
];

const CustomSelect = ({ value, onChange, options, disabled }) => {
    const [isOpen, setIsOpen] = useState(false);
    const containerRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const selectedOption = options.find(opt => opt.value === value) || options[0];

    return (
        <div className={`custom-dropdown-container ${disabled ? 'disabled' : ''}`} ref={containerRef}>
            <button
                type="button"
                className="custom-dropdown-trigger"
                onClick={() => !disabled && setIsOpen(!isOpen)}
                disabled={disabled}
            >
                <span>{selectedOption?.label}</span>
                <ChevronDown size={14} className={`chevron-icon ${isOpen ? 'open' : ''}`} />
            </button>
            {isOpen && (
                <div className="custom-dropdown-menu">
                    {options.map((opt) => (
                        <div
                            key={opt.value}
                            className={`custom-dropdown-item ${opt.value === value ? 'selected' : ''}`}
                            onClick={() => {
                                onChange(opt.value);
                                setIsOpen(false);
                            }}
                        >
                            {opt.label}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default CustomSelect;
